import type { EventDto } from "mws-catalog-ts-sdk";

export const isEventDto = (item: unknown): item is EventDto =>
  typeof item === "object" &&
  item !== null &&
  "eventType" in item &&
  "externalId" in item &&
  "slug" in item;
